import styles from "./toggelSwictherV2.module.scss";
import { svgImages } from "@/lib/svgImages";

export default function ToggleSwitchV2({
  isChecked,
  setIsChecked,
  firstVal,
  firstIcon,
  secondVal,
  secondIcon,
  pricingPage,
  menoPage = false,
  isRTL = false,
}) {
  const arrowIcon = (
    <span
      dangerouslySetInnerHTML={{
        __html: isRTL ? svgImages.arrowLeft : svgImages.arrowRight,
      }}
    />
  );

  return (
    <>
      <div
        className={`${styles["toggleSwitchContainer"]} ${menoPage ? styles["menoPage"] : ""} ${isRTL ? styles["rtl"] : ""}`}
      >
        <div className={`${styles["toggleSwitch"]}`}>
          <input
            type="radio"
            id="secondVal"
            name="toggle"
            checked={!isChecked}
            onChange={() => setIsChecked(false)}
          />
          <label
            htmlFor="secondVal"
            className={`${isChecked ? "" : styles["active"]} font-size-32`}
          >
            {isRTL ? arrowIcon : secondIcon}
            {secondVal}
          </label>
          <input
            type="radio"
            id="firstVal"
            name="toggle"
            checked={isChecked}
            onChange={() => setIsChecked(true)}
          />
          <label
            htmlFor="firstVal"
            className={`${isChecked ? styles["active"] : ""} font-size-32`}
          >
            {isRTL ? arrowIcon : firstIcon}
            {firstVal}
          </label>
          <div className={`${styles["switch"]}`}></div>
        </div>
        {pricingPage && (
          <div className={`${styles["offerText"]}`}>
            <span>Save up to 25% with our annual plans</span>
          </div>
        )}
      </div>
    </>
  );
}
